<script>

    import { toast } from 'bulma-toast'
    import { notificationStore, notificationsStore, modalStore } from '../stores'
    
    import NotificationsService from '../$services/notifications.service'

    import Form from '../$components/form.svelte'
    import InputText from '../$components/input.text.svelte'

    import Switch from '../$components/switch.svelte'
    import Date from '../$components/date.svelte'

    import ButtonModal from '../$components/button.modal.svelte'
    import Button from '../$components/button.svelte'

    const data = new Object({
        _id: $notificationStore._id,
        subject: $notificationStore.subject,
        message: $notificationStore.message,
        important: $notificationStore.important,
        expired: $notificationStore.expired
    })
    
    let loading = false

    async function updateNotification() {

        loading = true
        const resp = await NotificationsService.updateNotification(data._id, data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        notificationsStore.replace(data._id, resp.data)
        notificationStore.set(resp.data)

        toast({message: 'Notificación actualizada', type: 'is-success'})
        modalStore.set('notification_modal')
    }

</script>

<Form on:submit={ updateNotification } { loading } >
    <div class="columns">
        <div class="column">
            <InputText bind:value={ data.subject } label="Tema" placeholder="Tema" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={ data.message } label="Mensaje" placeholder="Mensaje" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Switch bind:checked={data.important} label="¿Notificación urgente?" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Date bind:value={data.expired} label="Fecha de expiración" />
        </div>
    </div>
    <div class="items-end">
        <div class="buttons">
            <ButtonModal modalId="notification_modal" icon="ban" text="Cancelar" color="light" />
            <Button type="submit" text="Guardar" icon="save" color="primary" { loading } />
        </div>
    </div>
</Form>